import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "src/app/shared/services/api.service";
import { IUserPermissions } from "../interfaces/access.interface";
import { IChangeLanguage, IExposedUser } from "../interfaces/user.interface";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private api: ApiService) {}

  /**
   * Get user infos
   * @return The current user's exposed information
   */
  public getUserInfos(): Observable<IExposedUser> {
    return this.api.get("users/info") as Observable<IExposedUser>;
  }

  /**
   * Changes the language the current user's account and emails are set to.
   * @param langCode Code of the language to switch to.
   * @return Success or error.
   */
  public changeLanguage(langCode: string): Observable<void> {
    return this.api.patch("user/language", { langCode } as IChangeLanguage) as Observable<void>;
  }

  /**
   * Gets the functionalities and routes the current user's role grants in the organization the
   * session is scoped to, without issuing new tokens.
   * @return The current organization along with its granted functionalities and routes
   */
  public getPermissions(): Observable<IUserPermissions> {
    return this.api.get("user/permissions") as Observable<IUserPermissions>;
  }
}
